<template>
    <modal id="create-user">
        <template slot="title">Create User</template>
        <template slot="body">
            <user-form :form="form"></user-form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal('create-user')">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="form.isSubmitted" @click="save()">Save</button>
        </template>
    </modal>
</template>
<script>

    let UserAvatar = require('@/mixins/Management/UserAvatar')

    export default {

        mixins:[UserAvatar],

        props: {
            users: {
                type: Array,
                required: true,
            }
        },

        data () {
            return {
                form: new Form ({
                    name: '',
                    last: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    team_id: null,
                    phone_number: '',
                    notes: '',
                    roles: [],
                })
            }
        },

        methods: {

            save(){
                this.form.post('/management/users').then(response => {
                    this.users.unshift(response);
                    this.closeModal('create-user');
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            },
        },
    }
</script>
